/* ============================================================
   Анимированные счётчики в полосе доверия (data-count).
   ============================================================ */
import { qsa } from '../dom';

function runCount(el: HTMLElement): void {
  if (el.dataset.done) return;
  el.dataset.done = '1';

  const target = Number(el.dataset.count);
  const suffix = el.dataset.suffix ?? '';
  const step = Math.max(1, Math.ceil(target / 45));
  let cur = 0;

  const id = window.setInterval(() => {
    cur += step;
    if (cur >= target) {
      cur = target;
      window.clearInterval(id);
    }
    el.textContent = cur + suffix;
  }, 24);

  // Гарантируем финальное значение.
  window.setTimeout(() => {
    window.clearInterval(id);
    el.textContent = target + suffix;
  }, 1600);
}

export function initCounters(): void {
  const els = qsa<HTMLElement>('[data-count]');

  els.forEach((el) => {
    const io = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            runCount(el);
            obs.disconnect();
          }
        });
      },
      { threshold: 0.4 },
    );
    io.observe(el);
  });

  // Подстраховка для элементов, уже видимых при загрузке.
  window.addEventListener('load', () =>
    window.setTimeout(
      () =>
        els.forEach((el) => {
          const r = el.getBoundingClientRect();
          if (r.top < window.innerHeight && r.bottom > 0) runCount(el);
        }),
      900,
    ),
  );
}
